'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdOfflinePin = function MdOfflinePin(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm17.2 23.4l11.2-11.2-2.4-2.4-8.8 8.9-3.2-3.2-2.4 2.3z m11.2 6.6v-3.4h-16.8v3.4h16.8z m-8.4-26.6c9.1 0 16.6 7.5 16.6 16.6s-7.5 16.6-16.6 16.6-16.6-7.5-16.6-16.6 7.5-16.6 16.6-16.6z' })
        )
    );
};

exports.default = MdOfflinePin;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/offline-pin.js
// module id = 2598
// module chunks = 0